const isProd = process.env.REACT_APP_ENVIRONMENT === "production";
const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

// En prod et localhost: localStorage (persistant)
// En recette: sessionStorage (session uniquement)
const shouldUsePersistentStorage = isProd || isLocalhost;

/**
 * Récupère le storage approprié selon l'environnement.
 * En production/localhost: localStorage (persistant entre sessions).
 * En recette: sessionStorage (durée de la session uniquement).
 */
export const getEnvironmentStorage = (): Storage => {
	return shouldUsePersistentStorage ? localStorage : sessionStorage;
};

/**
 * Récupère une valeur du storage selon l'environnement.
 */
export const getStorageItem = (key: string): string | null => {
	return getEnvironmentStorage().getItem(key);
};

/**
 * Sauvegarde une valeur dans le storage selon l'environnement.
 */
export const setStorageItem = (key: string, value: string): void => {
	getEnvironmentStorage().setItem(key, value);
};

/**
 * Supprime une valeur du storage selon l'environnement.
 */
export const removeStorageItem = (key: string): void => {
	getEnvironmentStorage().removeItem(key);
};
